import React, { useEffect } from 'react';
import {
  Router, Switch, Route,
} from 'react-router-dom';
import PATH from 'routes/path';
import fb from 'firebaseConfig';
import { createBrowserHistory } from 'history';
import Landing from 'pages/Landing';
import Login from 'pages/Login';
import SignUp from 'pages/SignUp';
import Eula from 'pages/Eula';
import Privacy from 'pages/Privacy';
import Home from 'pages/Home';
import UserData from 'pages/UserData';
import Calculation from 'pages/Calculation';
import Payment from 'pages/Payment';
import Documents from 'pages/Documents';
import Download from 'pages/Download';
import Error404 from 'pages/Error404';
import Results from 'pages/Results';
import Assecivil from 'pages/Assecivil';
import Maintenance from 'pages/Maintenance';
import Atermacao from 'pages/Atermacao';

import PublicRoute from './PublicRoute';
import PrivateRoute from './PrivateRoute';

// Retorna um componente de rota pública
function getRoute(path, component) {
  return (
    <PublicRoute
      exact
      path={path}
      component={component}
    />
  );
}

// Retorna um componente de rota de rota privada
function getPrivateRoute(path, component) {
  return (
    <PrivateRoute
      exact
      path={path}
      component={component}
    />
  );
}

const MainRouter = () => {
  const history = createBrowserHistory();
  // const { currentUser } = useContext(AuthContext);
  history.listen(() => {
    fb.analytics().logEvent(window.location.pathname + window.location.search);
  });

  useEffect(() => {
    fb.analytics().logEvent(window.location.pathname + window.location.search);
  }, []);

  return (
    <Router history={history}>
      <Switch>
        {/* ROTA DE MANUTENÇÃO */}
        <Route
          exact
          path={PATH.MAINTENANCE}
          component={Maintenance}
        />
        {/* ROTAS PÚBLICAS */}
        {getRoute(PATH.LANDING, Landing)}
        {getRoute(PATH.LOGIN, Login)}
        {getRoute(PATH.SIGNUP, SignUp)}
        {getRoute(PATH.ASSECIVIL, Assecivil)}
        {getRoute(PATH.EULA, Eula)}
        {getRoute(PATH.PRIVACY, Privacy)}

        {/* ROTAS PRIVADAS */}
        {getPrivateRoute(PATH.HOME, Home)}
        {getPrivateRoute(PATH.USER_DATA, UserData)}
        {getPrivateRoute(PATH.CALCULATION, Calculation)}
        {getPrivateRoute(PATH.PAYMENT, Payment)}
        {getPrivateRoute(PATH.DOCUMENTS, Documents)}
        {getPrivateRoute(PATH.ATERMACAO, Atermacao)}
        {getPrivateRoute(PATH.DOWNLOAD, Download)}
        {getPrivateRoute(PATH.RESULTS, Results)}

        {/* 404 */}
        <Route component={Error404} />
      </Switch>
    </Router>
  );
};

export default MainRouter;
